// Downscale a picked photo to a square-bounded JPEG so a phone photo (often > 5 MB) uploads
// small and fast. Falls back to the original file when the browser cannot decode or encode it.
export async function resizeImage(file, maxSize = 512, quality = 0.85) {
  try {
    const bitmap = await createImageBitmap(file)
    const scale = Math.min(1, maxSize / Math.max(bitmap.width, bitmap.height))
    const canvas = document.createElement('canvas')
    canvas.width = Math.round(bitmap.width * scale)
    canvas.height = Math.round(bitmap.height * scale)
    const ctx = canvas.getContext('2d')
    ctx.fillStyle = '#ffffff' // JPEG has no alpha: a transparent PNG would turn black
    ctx.fillRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
    bitmap.close?.()
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality))
    return blob ? new File([blob], 'avatar.jpg', { type: 'image/jpeg' }) : file
  } catch {
    return file
  }
}
